module.exports = __webpack_public_path__ + "static/media/md-cart.40fe4e3a.svg";